import { kioskLocation } from "../App/kioskRoutes";
import { createContext, useContext } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useIdleTimeout } from "../hooks/useIdleTimeout";

const KioskContext = createContext({ isKiosk: false });

export function KioskProvider({ children }) {
  const history = useHistory();
  const location = useLocation();
  const isLoginPage = location.pathname === "/kiosk";
  const { WarningModal } = useIdleTimeout({
    idleSeconds: 90,
    countdownSeconds: 20,
    onTimeout: () => history.push(kioskLocation("/kiosk", history.location)),
    enabled: !isLoginPage,
  });

  return (
    <KioskContext.Provider value={{ isKiosk: true }}>
      {children}
      {WarningModal}
    </KioskContext.Provider>
  );
}

export function useKiosk() {
  return useContext(KioskContext);
}
